const initailState = {
  loading: false,
  userData: null,
  accountType: null,
  accountSetUp: false,
  VerifyGstAccount: false,
  myOrganization: {},
};

export function authReducer(
  state = initailState,
  { type, userType, accountStatus, VerifyGstAccount, payload }
) {

  switch (type) {
    case "LOGGING_IN":
      return { ...state, loading: true };

    case "SHOW_LOADING":
      return { ...state, loading: true };

    case "HIDE_LOADING":
      return { ...state, loading: false };

    case "LOGGED":
      return { ...state, loading: false };
    case "CANNOT_LOGIN":
      return { ...state, loading: false };
    case "SET_USER":
      return { ...state, loading: false };
    case "MY_ORGANIZATION":
      return { ...state, loading: false, myOrganization: payload };

    case "UPDATE_USER_TYPE":
      return { ...state, loading: true };

    case "UPDATE_USER_TYPE_SUCCESS":
      return {
        ...state,
        loading: false,
        accountType: userType,
      };

    case "UPDATE_ACCOUNT_STATUS":
      return {
        ...state,
        loading: false,
        accountSetUp: accountStatus,
        VerifyGstAccount: VerifyGstAccount,

      };

    case "GET_MY_ORGANIZATION":
      return { ...state, loading: true };
    case "UPDATE_USER_TYPE_FAILED":
      return { ...state, loading: false };
    default:
      return state;
  }
}

export const profileReducer = (
  state = {
    loading: false,
    profile: {},
  },
  { type, payload }
) => {
  switch (type) {
    case "GET_USER_PROFILE":
      return { ...state, loading: true };
    case "GET_USER_PROFILE_SUCCESS":
      return { ...state, loading: false, profile: payload };
    case "GET_USER_PROFILE_FAILED":
      return { ...state, loading: false };
    default:
      return state;
  }
};

export const accountTypeReducer = (
  state = {
    loading: false,
    accountRes: null,
  },
  { type, payload }
) => {
  switch (type) {
    case "SHOW_ACCOUNT_TYPE_LODDING":
      return { ...state, loading: true };
    case "GET_ACCOUNT_TYPE":
      return { ...state, loading: false, accountRes: payload };
    case "HIDE_ACCOUNT_TYPE_LODDED":
      return { ...state, loading: false };
    default:
      return state;
  }
};

export const newRegisterUserReducer = (
  state = {
    sessionId: "",
    phoneNumber: "",
    otpSessionId: "",
  },
  { type, payload, phoneNumber }
) => {
  switch (type) {
    case "REGISTER_PHONE_NUMBER":
      return { ...state, sessionId: payload, phoneNumber: phoneNumber };
    case "OTP_VERIFICATION":
      return { ...state, otpSessionId: payload };
    default:
      return state;
  }
};
